import DataDeclaration from 'components/DataDeclaration'
import { getQuestionData } from 'components/MainComponent/QuestionData'
import MultiInputQuestion from 'components/MultiInputQuestion'
import Question from 'components/Question'
import {
  readLocalStorage,
  writeToLocalStorage,
} from 'components/Utils/localstorage'
import { _t } from 'components/Utils/translation'
import { useEffect, useRef, useState } from 'react'
import { scrollIntoView } from 'scrollIntoView'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)

const Survey = ({
  lang,
  setUserState,
  colorMode,
}: {
  lang: 'de' | 'fr'
  setUserState: (a: boolean, b: Answers) => void
  colorMode: 'light' | 'dark' | undefined
}) => {
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const [Questions, setQuestions] = useState<QuestionCollection>()
  const [useSingleDuration, setUseSingleDuration] = useState<boolean>(false)
  const [consentAccepted, setConsentAccepted] = useState<boolean | undefined>(
    undefined
  )
  const [answers, setAnswers] = useState<Answers>()
  // const [userHasAnswered, setUserHasAnswered] = useState<boolean>(false)

  const [unansweredQuestions, setUnansweredQuestions] = useState<number[]>(
    [...Array(21)].map((_, i) => i + 1)
  )

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (
      localStorage.getItem('sexumfrage2024_consentAccepted') === null &&
      consentAccepted
    ) {
      scrollIntoView(containerRef.current as HTMLElement)
    }
    if (consentAccepted) {
      localStorage.setItem(
        'sexumfrage2024_consentAccepted',
        JSON.stringify({ accepted: 'yes' })
      )
    }
  }, [consentAccepted])

  const handleAnswer = (
    id: string,
    value: string | number,
    questionNumber?: number
  ) => {
    if (questionNumber || questionNumber === 0) {
      setUnansweredQuestions(
        unansweredQuestions.filter((f) => f !== questionNumber)
      )
    }

    setAnswers({ ...answers, [id]: value })
  }
  useEffect(() => {

    setQuestions(getQuestionData(lang))
  }, [])

  useEffect(() => {
    if (answers) {
      writeToLocalStorage(answers)
    }
  }, [answers])

  useEffect(() => setQuestions(getQuestionData(lang)), [lang])

  useEffect(() => {
    const storedAnswers = readLocalStorage()
    const consentAccepted = localStorage.getItem(
      'sexumfrage2024_consentAccepted'
    )
    if (consentAccepted) {
      setConsentAccepted(true)
    }

    if (storedAnswers) {
      setAnswers(storedAnswers)
      var answered: number[] = []

      Object.entries(storedAnswers)
        .filter((f) => !f[0].includes('group_agree_'))
        .map(([key, _]) => {
          if (
            Questions &&
            Questions[key] &&
            (Questions[key].sort || Questions[key].sort === 0)
          ) {
            var q: any = Questions[key]
            answered.push(q.sort + 1)
          }
        })
      setUnansweredQuestions(
        unansweredQuestions.filter((f) => !answered.includes(f))
      )
      if (validateAnswers(storedAnswers)) {
        setUserState(storedAnswers.send === true, storedAnswers)
      }
    }
  }, [Questions])

  function validateAnswers(answers: Answers) {
    if (!Questions) return false
    const answerscopy = JSON.parse(JSON.stringify(answers))
    delete answerscopy.send

    if (
      Object.keys(answerscopy).filter((f) => !f.includes('group_agree_'))
        .length !==
      Object.entries(Questions || {}).filter((f: any) => {
        return (
          f[1].inputtype !== 'none' &&
          !f[0].includes('group_agree_') &&
          !f[0].includes('_single')
        )
      }).length
    ) {
      console.log('not all questions answered')
      return false
    }
    return true
  }

  if (consentAccepted === false) {
    return (
      <DataDeclarationContainer>
        {_t('disagreed to consent')}
        <ButtonContainer>
          <Button onClick={() => window.location.reload()}>
            {_t('back to consent')}
          </Button>
        </ButtonContainer>
      </DataDeclarationContainer>
    )
  }

  function handleConsentChange(e: boolean) {
    setConsentAccepted(e)
  }

  return (
    <Container ref={containerRef}>
      {consentAccepted === undefined && (
        <>
          <Overlay />
          <DataDeclaration
            lang={lang}
            check={handleConsentChange}
            colorMode={colorMode}
          />
        </>
      )}

      <SurveyContainer
        style={{
          paddingTop: '90px',
          paddingBottom: isMobile ? '50px' : '300px',
        }}
      >
        <SideImage
          src={require('../../images/top_1' +
            (colorMode === 'dark' ? '_dm' : '') +
            '.png')}
          style={{
            left: '50%',
            transform: 'translateX(-50%)',
            top: 0,
            opacity: 1,
            width: isMobile ? '1200px' : '100%',
            minWidth: '100%',
          }}
        />
        <SurveyPartTitle>{_t('first some personal questions')}</SurveyPartTitle>
        {
          <>
            {[
              ['gender', 1],
              ['age', 2],
              ['education', 3],
              ['relationship_status', 4],
              ['relationship_duration', 5],
              ['sexual_orientation', 6],
            ].map(([id, num]) => {
              if (!Questions) return null
              var q = Questions[id]
              if (q.unit==="Jahre" && lang==="fr"){
                q.unit="ans"
              }
              if (
                id === 'relationship_duration' &&
                answers &&
                answers.relationship_status === 'single'
              ) {
                q = Questions['relationship_duration_single']
              }

              return (
                <Question
                  key={'Q_' + num}
                  questionNumber={+num}
                  data={q}
                  onChange={handleAnswer}
                  answer={answers ? answers[id] : undefined}
                />
              )
            })}
          </>
        }
        <SideImage
          src={require('../../images/bottom_1' +
            (colorMode == 'dark' ? '_dm' : '') +
            '.png')}
          style={{
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: 0,
            opacity: 1,
            width: isMobile ? '1200px' : '100%',
            minWidth: '100%',
          }}
        />
      </SurveyContainer>
      <SurveyContainer
        style={{
          backgroundColor: 'var(--site-background)',
          paddingTop: '30px',
          paddingBottom: '260px',
        }}
      >
        <SurveyPartTitle>{_t('now questions to sexuality')}</SurveyPartTitle>
        {
          <>
            {Questions && (
              <>
                {[
                  ['satisfaction', 7],
                  ['sex_frequency', 8],
                  ['sex_frequency_desired', 9],
                  ['orgasm_frequency_sex', 10],
                  ['orgasm_frequency_desired', 11],
                  ['pleasure_frequency_sex', 12],
                  ['masturbation_frequency', 13],
                  ['orgasm_frequency_masturbation', 14],
                  ['pleasure_frequency_masturbation', 15],
                ].map(([id, num]) => (
                  <Question
                    key={'Q' + id + num}
                    questionNumber={+num}
                    data={Questions[id]}
                    onChange={handleAnswer}
                    answer={answers ? answers[id] : undefined}
                    inverted
                  />
                ))}
              </>
            )}

            {Questions && Questions.group_agree && (
              <MultiInputQuestion
                inverted
                questionNumber={16}
                question_frame={Questions.group_agree}
                data={[
                  Questions.group_agree_like,
                  Questions.group_agree_demand,
                  Questions.group_agree_think,
                ]}
                onChange={handleAnswer}
                answers={[
                  answers ? answers.group_agree_like : undefined,
                  answers ? answers.group_agree_demand : undefined,
                  answers ? answers.group_agree_think : undefined,
                ]}
              />
            )}

            {Questions && (
              <>
                {[
                  ['genital_look', 17],
                  ['genital_function', 18],
                  ['realize_sexual_demands', 19],
                  ['communicate_needed_mood', 20],
                  ['right_to_orgasm', 21],
                ].map(([id, num]) => (
                  <Question
                  key={'Q' + id + num}

                    questionNumber={+num}
                    data={Questions[id]}
                    onChange={handleAnswer}
                    answer={answers ? answers[id] : undefined}
                    inverted
                  />
                ))}
              </>
            )}

            <ButtonRow>
              <SendInfo>
                <UnansweredTitle>
                  {getAnsweredCount(answers)} {_t('answered allready')}
                </UnansweredTitle>
                <UnansweredContainer>
                  {unansweredQuestions.length > 0 &&
                    [...Array(21)]
                      .map((_, i) => i + 1)
                      .map((q) => {
                        return (
                          <UnanswerdButton
                          key={"unanswered_"+q}
                            style={{
                              backgroundColor: unansweredQuestions.includes(q)
                                ? 'var(--purple-bright-2)'
                                : 'var(--purple-main)',
                            }}
                            onClick={() => {
                              if (Questions) {
                                var el = containerRef.current?.querySelector(
                                  '#q' + q
                                )
                                if (el) scrollIntoView(el as HTMLElement)
                              }
                            }}
                          >
                            {q}
                          </UnanswerdButton>
                        )
                      })}
                </UnansweredContainer>
                {((answers && getAnsweredCount(answers) < 21) || !answers) && (
                  <SendText>{_t('answer all')}</SendText>
                )}
                {answers && getAnsweredCount(answers) === 21 && (
                  <SendButton
                    style={{
                      backgroundColor: 'var(--yellow-main',
                      color: 'var(--purple-dark-1)',
                    }}
                    onClick={() => {
                      if (answers) {
                        if (validateAnswers(answers)) {
                          if ((window as any).scrollTarget) {
                            window.scrollTo(0, (window as any).scrollPos)
                            // scrollIntoView((window as any).scrollTarget, false)
                          }
                          writeToLocalStorage(answers)
                          setUserState(true, answers)
                        } else {
                          console.log('error writing to database')
                        }
                      }
                    }}
                  >
                    {_t('send')}
                  </SendButton>
                )}
              </SendInfo>
            </ButtonRow>
          </>
        }
      </SurveyContainer>
    </Container>
  )
}

function getAnsweredCount(answers: Answers | undefined) {
  if (!answers) return 0
  return Object.keys(answers).filter(
    (f) => !f.includes('group_agree_') && f !== 'send'
  ).length
}

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-color: var(--overlay-color);
  z-index: 100;
  margin-left: -28px;
  margin-right: -28px;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
`

const UnansweredTitle = styled.div`
  font-size: 14px;
  color: var(--purple-bright-2);
  margin-bottom: 5px;
`

const UnansweredContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* max-width: 350px; */
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  gap: 6px;
`
const UnanswerdButton = styled.button`
  border: 0;
  background-color: var(--purple-bright-1);
  font-size: 14px;
  width: 30px;
  height: 30px;
  color: var(--purple-dark-1);
  /* padding: 5px 0px; */
  border-radius: 50%;
  padding: 0;
  text-align: center;
  &:hover {
    cursor: pointer;
    background-color: var(--purple-bright-2);
  }
`
const Container = styled.div``

const SurveyPartTitle = styled.p`
  z-index: 1;
  position: relative;
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 60px;
`
const Numbers = styled.div`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
`
const SendInfo = styled.div`
  /* max-width: 628px; */
  /* box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.4); */
  box-shadow: 0px 10px 15px rgba(167, 87, 163, 0.2),
    0px 30px 80px rgba(0, 0, 0, 0.2);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0px;
  color: var(--input-active-color);
  color: #fff;
  background-color: #fff;
  padding: 20px;
  padding-top: 40px;
  padding-bottom: 30px;
  line-height: 1.3em;
  background-color: var(--input-active-color);
  border-radius: 10px;
`

const SendText = styled.div`
  width: 100%;
  flex: 0 0 100%;
  margin-bottom: 0px;
  display: inline-block;
  width: 100%;
  margin-bottom: 15px;
  font-size: 18px;
  /* max-width: 400px; */
  /* max-width: 350px; */
  @media screen and (max-width: 711px) {
    width: calc(100vw - 80px);
  }
`

const SideImage = styled.img`
  position: absolute;
  z-index: 1;
  opacity: 0.5;
  max-width: calc(100% + 56px);
`

const ButtonRow = styled.div`
  text-align: center;
  position: relative;
  z-index: 40;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 30px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 10px;
  @media screen and (max-width: 1679px) {
    bottom: -20px;
  }
  @media screen and (max-width: 1023px) {
    bottom: -20px;
  }
`
const SurveyContainer = styled.div.attrs({ className: 'survey-container' })`
  background-color: var(--beige-bright-3);
  background-color: var(--section-bg);
  padding: 15px;
  padding-left: 0;
  padding-right: 0;
  position: relative;
  width: calc(100% + 56px);
  margin-left: -28px;
  margin-right: -28px;
margin-bottom: 60px;
  @media screen and (max-width: 1679px) {
    /* padding-bottom: 200px; */
  }
  @media screen and (max-width: 1023px) {
    /* padding-bottom: 120px; */
  }
  @media screen and (max-width: 712px) {
    margin-left: unset;
    margin-right: unset;
    width: calc(100% + 40px);
    max-width: calc(100% - 40px);
    padding-left: 20px;
    padding-right: 20px;
  }
`
const SendButton = styled.button`
  background-color: transparent;
  color: #fff;
  padding: 20px 40px;
  font-size: 22px;
  border: 0;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
  }
`
export default Survey

const DataDeclarationContainer = styled.div`
  position: sticky;
  top: 100px;
  z-index: 40;
  z-index: 2003;
  font-size: 18px;
  letter-spacing: 0.3px;
  /* font-style: italic; */
  line-height: 1.5em;
  padding: 30px;
  /* border: 1px solid var(--beige-bright-1); */
  /* background-color: var(--beige-bright-3); */
  color: var(--beige-dark-1);
  max-width: 630px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  margin-bottom: 30px;
  @media screen and (max-width: 711px) {
    /* padding-left: 0;
    padding-right: 0; */
    margin-top: 30px;
    font-size: 15px;
    max-width: calc(100vw - 40px);
    margin-left: 20px;
    margin-right: 20px;
    padding: 15px;
  }
  border-radius: 10px;
  background-color: var(--purple-main);
  color: #fff;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.4);
`

const Button = styled.button`
  font-family: var(--font-sans-serif);
  background-color: #fff;
  color: var(--brandblue-main);
  padding: 10px 20px;
  border: 0;
  min-width: 100px;
  margin-right: 2px;
  font-size: 18px;
  margin-top: 15px;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`

const ButtonContainer = styled.div`
  width: 100%;
  text-align: center;
  padding-top: 30px;
  font-size: 22px;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`
